// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../breakpoints.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_list__3GwO9 {
    list-style: none;
    padding: 0;
    margin: 0;
    background: #ffffff;
    border: 1px solid var(--primary-color-active);
    border-radius: 2px;
    width: 100%;
    min-height: 40px;
}

.styles_list__3GwO9 li {
    padding: 9px 20px;
    display: flex;
    align-items: center;
    min-height: 40px;
}

.styles_list__3GwO9 li:not(:last-child) {
    border-bottom: 1px solid var(--primary-color-active);
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    .styles_list__3GwO9,
    .styles_list__3GwO9 li {
        min-height: 32px;
    }

    .styles_list__3GwO9 li {
        padding: 8px 20px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/SelectedValuesList/styles.module.css"],"names":[],"mappings":"AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,mBAAmB;IACnB,6CAA6C;IAC7C,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI;;QAEI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":["@value screen-md-max, screen-lg-min from '../../breakpoints.css';\n\n.list {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    background: #ffffff;\n    border: 1px solid var(--primary-color-active);\n    border-radius: 2px;\n    width: 100%;\n    min-height: 40px;\n}\n\n.list li {\n    padding: 9px 20px;\n    display: flex;\n    align-items: center;\n    min-height: 40px;\n}\n\n.list li:not(:last-child) {\n    border-bottom: 1px solid var(--primary-color-active);\n}\n\n@media screen-md-max {\n    .list,\n    .list li {\n        min-height: 32px;\n    }\n\n    .list li {\n        padding: 8px 20px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-md-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]}`,
	"screen-lg-min": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]}`,
	"list": `styles_list__3GwO9`
};
export default ___CSS_LOADER_EXPORT___;
